import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    checkboxContainer:
      'group relative flex items-start bg-transparent md:items-center',
    checkbox:
      'border-bg-main-inversion group-hover:border-icon-hover data-[checked]:bg-text-main group-hover:data-[checked]:border-brand-primary group-hover:data-[checked]:bg-brand-primary flex size-6 min-w-6 cursor-pointer items-center justify-center border transition-colors duration-200 focus:outline-none',
    label:
      'heading-m cursor-pointer pl-2 transition-colors duration-200 group-hover:text-gray-700',
    helperText: 'mt-1 text-[12px] font-light',
    icon: 'opacity-0 group-has-[[data-checked]]:opacity-100'
  },
  variants: {
    error: {
      true: {
        checkbox:
          'border-brand-primary group-has-[[data-checked]]:bg-brand-primary data-[checked]:bg-brand-primary',
        helperText: 'text-error border-brand-primary'
      }
    },
    disabled: {
      true: {
        label:
          'text-text-inactive group-hover:text-text-inactive cursor-not-allowed',
        checkbox:
          'cursor-not-allowed border-gray-500 group-hover:border-gray-500 data-[checked]:bg-gray-500'
      }
    }
  }
});
